@if ($fileError()) {
  <div class="mt-2" data-test-id="file-error-banner">
    <app-edit-permissions-banner [bannerType]="EditPermissionsBannerType.error" (onClose)="onCloseFileError()">
      {{ $fileError() }}
    </app-edit-permissions-banner>
  </div>
}

@if (tableRows$ | async; as tableRows) {
  @if (tableRows.length > 0) {
    <app-ngb-table [config]="tableConfig" [data]="tableRows" id="mobile-apps-table"></app-ngb-table>
    <div *featureFlag="FeatureFlagCollection.mobileAllowMultipleApps">
      @if (hasPermsToCreateMobileApps$ | async) {
        <button
          type="button"
          ds-button
          (click)="nativeInput.click()"
          [variant]="DsButtonVariants.microAction"
          data-test-id="upload-app"
          [icon]="Icons.Plus"
        >
          {{ 'upload_app' | translate }}
        </button>
      }
    </div>
  } @else {
    <div data-test-id="mobile-apps-empty-state">
      <ng-container [ngTemplateOutlet]="emptyState ?? defaultEmptyState"></ng-container>
    </div>
  }
}

<div [formGroup]="form">
  <input
    #nativeInput
    type="file"
    class="form-element d-none"
    [id]="formId"
    [accept]="acceptedExtensions"
    [formControlName]="FORM_FIELDS.appUpload"
    (change)="onFileUpload($event)"
  />
</div>

<ng-template #defaultEmptyState>
  <div class="d-flex flex-column align-items-start mt-2" data-test-id="mobile-apps-upload">
    @if (hasPermsToCreateMobileApps$ | async) {
      <button
        type="button"
        ds-button
        (click)="nativeInput.click()"
        data-test-id="upload-app"
        [attr.aria-label]="'add_app' | translate"
      >
        <ds-icon [icon]="Icons.Plus" style="color: unset" class="me-1"></ds-icon>
        <span>{{ 'app' | translate }}</span>
      </button>
    } @else {
      <ds-banner
        class="full-width mb-3"
        [state]="DsBannerState.info"
        [showTitle]="false"
        [showAction]="false"
        [showCloseButton]="false"
      >
        <div ds-banner-body>
          {{ 'no_permission_to_upload_app_info_banner_message' | translate }}
        </div>
      </ds-banner>

      <button type="button" ds-button data-test-id="upload-app" [disabled]="true" [attr.aria-label]="'add_app' | translate">
        <ds-icon [icon]="Icons.Plus" style="color: unset" class="me-1"></ds-icon>
        <span>{{ 'app' | translate }}</span>
      </button>
    }
    <p class="pt-2 text-center file-upload-subtext">
      <i>{{ 'supported_app_file' | translate: [acceptedExtensionsFormatted, MAX_GB] }} </i>
      <ds-link
        href="https://client.levelaccess.com/hc/en-us/articles/28446649502615-Beta-Mobile-accessibility-tester#h_01JEV3Z3Q8TJA1WM95BKBQJPZS"
        [external]="true"
        >{{ 'learn_more_about_supported_formats' | translate }}</ds-link
      >
    </p>
  </div>
</ng-template>
